import * as React from "react";
const SvgBatteryHorizontal0Percent20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 4H0v12h18v-3h2V7h-2V4H1Zm1 10V6h14v8H2Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryHorizontal0Percent20Px;
